import React from 'react';
import { ParallaxProvider } from "react-scroll-parallax";
import { ModalProvider } from './src/context/modalContext';

export const wrapRootElement = ({ element }) => <ModalProvider><ParallaxProvider>{element}</ParallaxProvider></ModalProvider>;
